import { render, staticRenderFns } from "./deliveryareaTodo_new.vue?vue&type=template&id=56ef976d&scoped=true"
import script from "./deliveryareaTodo_new.vue?vue&type=script&lang=js"
export * from "./deliveryareaTodo_new.vue?vue&type=script&lang=js"
import style0 from "./deliveryareaTodo_new.vue?vue&type=style&index=0&id=56ef976d&prod&lang=css"
import style1 from "./deliveryareaTodo_new.vue?vue&type=style&index=1&id=56ef976d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef976d",
  null
  
)

export default component.exports